(() => {
  if (window.__msR14Feedback) return;
  window.__msR14Feedback = true;

  // Filter feedback for the fabric library. The library rewrites the result
  // count with textContent, which no CSS transition can observe, so the change
  // is picked up here and replayed as a one-shot animation. Purely additive:
  // if this never runs the count still updates, it just does not flip.
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  const replay = (el) => {
    el.classList.remove('is-counted');
    void el.offsetWidth; // force a reflow so the animation restarts
    el.classList.add('is-counted');
  };

  const watch = (scope = document) => {
    scope.querySelectorAll('[data-ms-result-count]').forEach((el) => {
      if (el.dataset.msCountBound) return;
      el.dataset.msCountBound = '1';
      if (reduce.matches || !('MutationObserver' in window)) return;

      let last = el.textContent.trim();
      new MutationObserver(() => {
        const next = el.textContent.trim();
        if (next === last) return;
        last = next;
        replay(el);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => watch(), { once: true })
    : watch();

  document.addEventListener('shopify:section:load', (e) => watch(e.target));
})();
